/*
 * Public API Surface of authentication
 */

export * from './lib/guards/is-admin.guard';
export * from './lib/guards/auto-login.guard';

export * from './lib/services/authentication.service';

export * from './lib/interceptors/authorization-with-credentials.interceptor';

export * from './lib/models/authenticated-user.model';
export * from './lib/models/permission.model';
export * from './lib/models/application-permissions.model';
export * from './lib/models/company-permissions.model';
export * from './lib/models/roles-and-permissions-api.model';
export * from './lib/models/roles-and-permissions.model';

export * from './lib/authentication.module';
 